import React from "react";
import "../../assets/styles/Button.scss";

export interface ButtonProps {
  type?: keyof React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  onClick(): void;
  children: React.ReactNode;
  classes?: string;
  disabled?: boolean;
}

export interface ButtonState {}

export const Button = (props: ButtonProps) => {
  const { type, onClick, children, classes, disabled } = props;
  return (
    <button
      type={type || "button"}
      className={`button ${classes ? classes : ""}`}
      onClick={onClick}
      disabled={disabled || false}
    >
      {children}
    </button>
  );
};

export default Button;
